import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=10916679"
import script from "./Users.vue?vue&type=script&lang=ts"
export * from "./Users.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10916679')) {
      api.createRecord('10916679', component.options)
    } else {
      api.reload('10916679', component.options)
    }
    module.hot.accept("./Users.vue?vue&type=template&id=10916679", function () {
      api.rerender('10916679', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/groups/Users.vue"
export default component.exports